import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-plano-acao',
  templateUrl: './plano-acao.component.html',
  styleUrls: ['./plano-acao.component.scss']
})
export class PlanoAcaoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}